// extracted by mini-css-extract-plugin
export default {"projectList":"projectlist_projectList__un43G"};